<template>
  <div id="markdown-example">

    <v-layout column>
      <v-flex xs12 sm12 md12>
        <v-container fluid grid-list-md text-xs-left>
          <v-layout row wrap>
            <v-flex><h1 id="example-title">{{ title }}</h1></v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex>
              
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>

    
  </div>
</template>

<script>
// import VueMarkdown from '../../../src/VueMarkdown' // development
import VueMarkdown from 'vue-markdown' // production
export default {
  name: 'app',
  data () {
    return {
      title: 'Markdown Example',

      source: new Date().toLocaleTimeString(),
      anchorAttrs: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow'
      }
    }
  },
  components: {
    VueMarkdown
  },
  mounted () {
    setInterval(() => {
      this.source = new Date().toLocaleTimeString();
    }, 1000);
  }
}
</script>


// WEBPACK FOOTER //
// src/layouts/documentation/MarkdownExample.vue